module.exports = {
	"apiPayloadLimit": "20mb",
	"githubAppId": 39410,
	"webhookPort": 39411,
	"pemFilePath": "/home/jaid/secret.pem"
};